var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "the-search-suggestion" }, [
    _c(
      "a",
      {
        ref: "anchor",
        staticClass: "the-search-suggestion__link",
        attrs: { href: _vm.href },
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.click($event)
          },
          focus: function($event) {
            return _vm.$emit("focus")
          },
          focusout: function($event) {
            return _vm.$emit("focusout")
          }
        }
      },
      _vm._l(_vm.tokens, function(token, index) {
        return _c(
          "span",
          {
            key: index,
            class: [
              token.toLowerCase() === _vm.match.toLowerCase()
                ? "the-search-suggestion__match"
                : "the-search-suggestion__prediction"
            ]
          },
          [_vm._v(_vm._s(token))]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }